import { gql } from '@apollo/client';
import { graphql } from '@xolv-mybrightlink/common';
import {
  DimensionVideo,
  DimensionVideoListModel,
  DimensionWpPost,
} from '../models/DimensionVideoListModel';
import { VideoDetail } from '../models/VimeoResponse';

const GET_DIMENSION_VIDEOS_QUERY = gql`
  query dimensionVideos($page: Int) {
    dimensionVideos(page: $page) {
      hasMore
      videoList {
        name
        duration
        picture
        url
        width
        height
      }
    }
  }
`;

const GET_LMS_DIMENSION_POSTS_QUERY = gql`
  query dimensionWpPosts($languageCode: String) {
    dimensionWpPosts(languageCode: $languageCode) {
      id
      title
      name
      order
    }
  }
`;

const GET_DIMENSION_DETAIL_QUERY = gql`
  query dimensionDetails($postId: String!) {
    dimensionDetails(postId: $postId)
  }
`;

const GET_DIMENSION_TITLE_QUERY = gql`
  query dimensionTitle($postId: String!) {
    dimensionTitle(postId: $postId)
  }
`;

export const getdimensionVideoList = async (
  page: number,
  languageCode: string,
): Promise<DimensionVideoListModel> => {
  const vimeoResponse = await graphql.query<{
    dimensionVideos: { videoList: VideoDetail[]; hasMore: boolean };
  }>({
    query: GET_DIMENSION_VIDEOS_QUERY,
    variables: {
      page: page,
    },
  });
  const wpPostsResponse = await graphql.query<{
    dimensionWpPosts: DimensionWpPost[];
  }>({
    query: GET_LMS_DIMENSION_POSTS_QUERY,
    variables: {
      languageCode: languageCode,
    },
  });
  const wpPosts = wpPostsResponse.data.dimensionWpPosts;

  const wpPostsMap: { [key: string]: DimensionWpPost } = {};
  const wpPostByName = wpPosts.reduce((map, obj) => {
    map[obj.name] = obj;
    return map;
  }, wpPostsMap);
  const introductionPost = wpPostByName['What is Dimension Parent Class?'];
  console.log(wpPostByName);
  const list = vimeoResponse.data.dimensionVideos.videoList
    .map((video) => fromJson(video, wpPostByName[video.name]))
    .sort((a, b) => (a.wpPostOrder < b.wpPostOrder ? -1 : 1));
  const data = {
    introductionPost: introductionPost,
    hasMore: vimeoResponse.data.dimensionVideos.hasMore,
    videos: list,
  };
  return data;
};

export const getDimensionPostContent = async (
  postId: string,
): Promise<string> => {
  const response = await graphql.query<{
    dimensionDetails: string;
  }>({
    query: GET_DIMENSION_DETAIL_QUERY,
    variables: {
      postId: postId,
    },
  });
  console.log(response.data);
  return response.data.dimensionDetails;
};

export const getDimensionTitle = async (postId: string) => {
  const response = await graphql.query<{
    dimensionTitle: string;
  }>({
    query: GET_DIMENSION_TITLE_QUERY,
    variables: {
      postId: postId,
    },
  });
  return response.data.dimensionTitle;
};

const fromJson = (
  video: VideoDetail,
  post: DimensionWpPost,
): DimensionVideo => {
  return {
    title: post?.title ?? video.name ?? '',
    duration: video.duration,
    image: video.picture,
    url: video.url,
    width: video.width,
    height: video.height,
    description: video.description,
    wpPostId: post.id,
    wpPostOrder: post?.order ?? 0,
  };
};
